import React, { createContext, useContext, useReducer } from "react";
import { initialState, licitacoesReducer, LicitacoesState } from "./licitacoes-reducer";

type LicitacoesContextType = {
    state: LicitacoesState;
    dispatch: React.Dispatch<any>;
};

const LicitacoesContext = createContext<LicitacoesContextType | undefined>(undefined);

export const LicitacoesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(licitacoesReducer, initialState);

    return (
        <LicitacoesContext.Provider value={{ state, dispatch }}>
            {children}
        </LicitacoesContext.Provider>
    );
};

export const useLicitacoesState = () => {
    const context = useContext(LicitacoesContext);
    if (!context) {
        throw new Error("useLicitacoesState must be used within LicitacoesProvider");
    }
    return context.state;
};

export const useLicitacoesDispatch = () => {
    const context = useContext(LicitacoesContext);
    if (!context) {
        throw new Error("useLicitacoesDispatch must be used within LicitacoesProvider");
    }
    return context.dispatch;
};
